// extracted by mini-css-extract-plugin
module.exports = {"proportionChangeContainer":"lcI4Xl1P","proportionChangeContainerV2":"kVZ59ZyT","dateSpan":"r9S2x3qh","dateSpanV2":"FATNt5GF"};